var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 196,
    viewBox: "0 0 190 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M186.293 107.631C185.414 120.949 183.803 134.816 181.641 148.247C180.792 160.992 178.713 172.668 174.995 181.946C171.653 189.612 165.808 193.961 157.189 194.243C148.376 192.847 136.641 188.114 122.238 180.917C108.117 174.869 93.1104 169.172 78.2086 164.57C63.9797 162.478 49.9902 160.801 37.2077 158.687C25.3783 157.564 15.2678 154.467 8.00929 148.646C2.48275 142.511 0.435173 133.056 2.49412 120.24C6.25275 107.023 13.0398 92.0319 21.6166 76.5724C30.3007 61.4181 39.9819 46.4893 50.0143 33.1538C59.6903 21.0114 70.0319 11.2968 80.9648 5.14873C92.0147 0.802268 104.158 0.199204 117.084 3.625C130.194 7.83355 142.596 14.4509 153.54 22.3436C164.065 29.3081 172.711 37.1633 178.895 45.6921C184.471 53.2427 187.695 62.0786 188.486 72.3602C189.341 82.2137 188.536 93.9917 186.293 107.631Z",
    stroke: "#5A42ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "3 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector19);
export default __webpack_public_path__ + "static/media/Vector-19.14ebf590d40ff3ca1547ffdd4d15a249.svg";
export { ForwardRef as ReactComponent };